class PaymentDetail {
  public readonly id: string;
  public readonly type?: string;
  public readonly paymentNote?: string;
  public readonly paymentCurrency: string;
  public readonly paymentAmount: number;
  public readonly offerLinkText?: string;
  public readonly offerLinkHref?: string;
  public readonly postLinkText?: string;
  public readonly postLinkHref?: string;
  constructor({
    id,
    type,
    paymentNote,
    paymentCurrency,
    paymentAmount,
    offerLinkText,
    offerLinkHref,
    postLinkText,
    postLinkHref,
  }: {
    id: string;
    type?: string;
    paymentNote?: string;
    paymentCurrency: string;
    paymentAmount: number;
    offerLinkText?: string;
    offerLinkHref?: string;
    postLinkText?: string;
    postLinkHref?: string;
  }) {
    this.id = id;
    this.type = type;
    this.paymentNote = paymentNote;
    this.paymentCurrency = paymentCurrency;
    this.paymentAmount = paymentAmount;
    this.offerLinkText = offerLinkText;
    this.offerLinkHref = offerLinkHref;
    this.postLinkText = postLinkText;
    this.postLinkHref = postLinkHref;
  }

  public static fromJSON = (value: any) => {
    const { id, type, links, details, payment_currency, payment_amount } = Object.assign({}, value);
    const { offer_href, offer_text, post_href, post_text } = Object.assign({}, links);
    const { payment_note } = Object.assign({}, details);

    if (typeof id !== 'number') throw new TypeError('.id must be a number');
    if (type && typeof type !== 'string') throw new TypeError('.type must be a string');
    if (payment_note && typeof payment_note !== 'string') throw new TypeError('.details.payment_note must be a string');
    if (typeof payment_currency !== 'string') throw new TypeError('.payment_currency must be a string');
    if (typeof payment_amount !== 'number') throw new TypeError('.payment_amount must be a number');
    if (offer_text && typeof offer_text !== 'string') throw new TypeError('.links.offer_text must be a string');
    if (offer_href && typeof offer_href !== 'string') throw new TypeError('.links.offer_href must be a string');
    if (post_text && typeof post_text !== 'string') throw new TypeError('.links.post_text must be a string');
    if (post_href && typeof post_href !== 'string') throw new TypeError('.links.post_href must be a string');

    return new PaymentDetail({
      id: String(id),
      type,
      paymentNote: payment_note,
      paymentCurrency: payment_currency,
      paymentAmount: payment_amount,
      offerLinkText: offer_text,
      offerLinkHref: offer_href,
      postLinkText: post_text,
      postLinkHref: post_href,
    });
  };
}

export default PaymentDetail;
